import { Text, Timeline } from '@ksyos/design-system';
import { CollapseCard } from './CollapseCard';

const timeLineItems: { header: string; text: string }[] = [
    {
        header: 'Maak een afspraak',
        text: 'Maak een afspraak bij de optometrist voor een oogonderzoek',
    },
    {
        header: 'Wat neem je mee?',
        text: 'Breng je bril of contactlenzen en een lijst van je medicatie mee. Als je een verwijzing van je huisarts hebt, neem die ook mee',
    },
    {
        header: 'Het onderzoek',
        text: 'De optometrist voert onderzoeken uit om de gezondheid van je ogen te controleren',
    },
    {
        header: 'Beoordeling door de oogarts',
        text: 'Als het nodig is, worden de resultaten van het onderzoek naar een oogarts gestuurd. Binnen twee werkdagen krijgt de optometrist de beoordeling van de oogarts van Ksyos',
    },
    {
        header: 'Vervolg en advies',
        text: 'Als het nodig is, wordt een vervolgafspraak gemaakt of een behandelplan voorgesteld',
    },
];

type OptometryStepsCardProps = Readonly<{
    isInitiallyOpen?: boolean;
}>;

export function OptometryStepsCard({ isInitiallyOpen }: OptometryStepsCardProps) {
    return (
        <CollapseCard
            isInitiallyOpen={isInitiallyOpen}
            title="Vervolgstappen"
        >
            <Timeline>
                <>
                    {timeLineItems.map((item) => (
                        <Timeline.Item key={item.header}>
                            <Text fontWeight="medium">{item.header}</Text>
                            <Text>{item.text}</Text>
                        </Timeline.Item>
                    ))}
                </>
                <Timeline.Item key="deeljeervaring">
                    <Text fontWeight="medium">Deel je ervaring met ons</Text>
                    <Text>
                        Na het onderzoek ontvang je een e-mail. Als je wilt, kun je meedoen aan een telefonisch gesprek
                        van <strong>25 minuten</strong>. Je krijgt een waardebon van <strong>€30</strong> als dank. We
                        horen graag jouw mening over je ervaring met het oogonderzoek en onze zorg
                    </Text>
                </Timeline.Item>
            </Timeline>
        </CollapseCard>
    );
}
